import { useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { ArrowUpRight, Play, Maximize2 } from "lucide-react";

const portfolioItems = [
  {
    title: "Contenido Comercial — Producción de Marca",
    category: "Contenido & Producción",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/8lsdmtw2_IMG_0495.JPG",
    wide: true,
  },
  {
    title: "Activación de Marca — Weris App",
    category: "PR & Lanzamientos",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/bz5j8afn_d5617343-4a65-4254-80b3-f1e526a86e67.JPG",
    wide: false,
  },
  {
    title: "Cobertura de Evento — Activación Nocturna",
    category: "Eventos & Cobertura",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/nclwxurs_c78953b6-3895-4c9b-99ea-45e6f9837611.JPG",
    wide: false,
  },
  {
    title: "Documental Corporativo — Planta Industrial",
    category: "Producción Audiovisual",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/z8ziojft_IMG_4277.PNG",
    wide: false,
  },
  {
    title: "Vocería & Panel — Speaker Corporativo",
    category: "PR & Media Influence",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/e03o9uym_dd1fadcf-485f-434a-a7a2-ac7e8483b688.JPG",
    wide: true,
  },
  {
    title: "Experiencia Digital Interactiva",
    category: "Activaciones Digitales",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/fdv6kzva__RON7826.JPEG",
    wide: false,
  },
  {
    title: "Behind the Scenes — Gimbal & Cine",
    category: "Producción Audiovisual",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/qjhek4vl_IMG_4279.PNG",
    wide: false,
  },
  {
    title: "Branding & Merchandising — Flexiplan",
    category: "Contenido & Producción",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/jb8mnmzo__RON7007.JPEG",
    wide: false,
  },
  {
    title: "RSE — Voluntariado Corporativo",
    category: "Comunicación Social",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/bt59diun_C46B76BA-A79C-4D0F-9B4C-BEC1F768F4C8.PNG",
    wide: true,
  },
  {
    title: "Relaciones Públicas — Networking Corporativo",
    category: "Relaciones Públicas",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/dvms48p6_2e95e727-38ae-475d-870c-7bbab832bb23.JPG",
    wide: false,
  },
  {
    title: "Inclusión Social — Cobertura Documental",
    category: "Comunicación Social",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/3xqwz2mj_BC15FC3D-0131-4D4F-A2BC-86FC34C30ADA.PNG",
    wide: false,
  },
  {
    title: "Cobertura en Vivo — Audiencia Tech",
    category: "Eventos & Cobertura",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/gks6nvp8__RON7733.JPEG",
    wide: false,
  },
  {
    title: "Producción Audiovisual — Behind the Scenes",
    category: "Producción Audiovisual",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/jlg25svd_IMG_3416.JPG",
    wide: true,
  },
  {
    title: "Activación Flexiplan — Registro de Asistentes",
    category: "Eventos & Activaciones",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/fl8vgj9q__RON6942.JPEG",
    wide: false,
  },
  {
    title: "Comunidad — Impacto Social",
    category: "Comunicación Social",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/wyl7fboj_3DCF10E9-9DC9-4045-B8B0-A5356DDEF706.PNG",
    wide: false,
  },
  {
    title: "Narrativa Industrial — Operaciones",
    category: "Contenido Institucional",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/vr9msjba_IMG_4275.PNG",
    wide: false,
  },
  {
    title: "Equipo en Acción — Logística de Evento",
    category: "Eventos & Activaciones",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/akdw1v8l__RON6951.JPEG",
    wide: true,
  },
  {
    title: "Networking Corporativo — Flexiplan",
    category: "Relaciones Públicas",
    image: "https://customer-assets.emergentagent.com/job_disruptiva-redesign/artifacts/pry0ca8g__RON7002.JPEG",
    wide: false,
  },
];

const CanvaEmbed = () => {
  const [loaded, setLoaded] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="mt-12"
      data-testid="canva-portfolio-embed"
    >
      <div className="canva-embed-wrapper">
        {/* Label */}
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-1.5 rounded-full bg-purple-500/50" />
            <span className="text-[12px] text-white/25 font-space tracking-widest uppercase">
              Portafolio completo 2025–2026
            </span>
          </div>
          <a
            href="https://www.canva.com/design/DAHA3xOxCv8/JYZhgHm6BLw2HqJnnZLq8A/view"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-[12px] text-white/20 hover:text-white/50 transition-colors font-space"
            data-testid="canva-fullscreen-link"
          >
            <Maximize2 className="w-3.5 h-3.5" />
            Pantalla completa
          </a>
        </div>

        {/* Embed container */}
        <div className="canva-embed-frame">
          {!loaded && (
            <div className="absolute inset-0 flex items-center justify-center bg-white/[0.02] z-10">
              <div className="flex flex-col items-center gap-3">
                <div className="w-6 h-6 border-2 border-purple-500/20 border-t-purple-500/60 rounded-full animate-spin" />
                <span className="text-[11px] text-white/15 font-space">Cargando portafolio...</span>
              </div>
            </div>
          )}
          <iframe
            loading="lazy"
            src="https://www.canva.com/design/DAHA3xOxCv8/JYZhgHm6BLw2HqJnnZLq8A/view?embed"
            allowFullScreen
            allow="fullscreen"
            title="Portafolio Disruptiva 2025-2026"
            onLoad={() => setLoaded(true)}
            className={`canva-iframe ${loaded ? "opacity-100" : "opacity-0"}`}
          />
        </div>
      </div>
    </motion.div>
  );
};

export const PortfolioSection = ({ onOpenReel }) => {
  const ref = useRef(null);
  useInView(ref, { once: true, margin: "-80px" });

  return (
    <section id="portfolio" ref={ref} className="relative py-32" data-testid="portfolio-section">
      <div className="morph-bg w-[500px] h-[500px] bg-purple-700/8 top-[10%] right-[-10%]" />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="pulse-dot" />
            <span className="text-[13px] text-white/35 font-space tracking-widest uppercase">
              Portafolio
            </span>
          </div>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
            <h2 className="font-space font-bold text-4xl md:text-6xl text-white leading-tight">
              Trabajo
              <br />
              selecto
            </h2>
            <button
              onClick={onOpenReel}
              className="btn-glass group self-start md:self-auto"
              data-testid="open-reel-btn"
            >
              <Play className="w-4 h-4" />
              Ver Reel
            </button>
          </div>
        </motion.div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {portfolioItems.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className={`portfolio-card group ${item.wide ? "md:col-span-2" : ""}`}
              style={{ height: "clamp(260px, 30vw, 420px)" }}
              data-testid={`portfolio-item-${i}`}
            >
              <div className="portfolio-card-inner">
                <img
                  src={item.image}
                  alt={item.title}
                  className="portfolio-card-img"
                  loading="lazy"
                />
                <div className="portfolio-card-overlay">
                  <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                    <span className="text-[11px] text-purple-400/60 font-space tracking-widest uppercase">
                      {item.category}
                    </span>
                    <h3 className="font-space font-semibold text-base md:text-lg text-white mt-1.5 leading-snug">
                      {item.title}
                    </h3>
                  </div>
                  <div className="absolute top-5 right-5 w-9 h-9 rounded-full bg-white/[0.05] border border-white/[0.08] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 backdrop-blur-sm">
                    <ArrowUpRight className="w-4 h-4 text-white/60" />
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Canva Portfolio Embed */}
        <CanvaEmbed />
      </div>
    </section>
  );
};
